export const settingsAction = () => {
  return {
    type: 'TEST_ACTION'
  }
}

export const settingsPrevStep = () => {
  return {
    type: "SETTINGS_NEXT_STEP",
    step: 2
  }
}

export const settingsNextStep = (step) => {
  return {
    type: "SETTINGS_NEXT_STEP",
    step: step
  }
}

export const settingsSelectBackground = (background, backgroundSrc, backgroundColor) => {
  return {
    type: "SETTINGS_SELECT_BACKGROUND",
    background: background,
    backgroundSrc: backgroundSrc,
    backgroundColor: backgroundColor
  }
}

export const settingsSelectForeground = (foregroundSrc) => {
  return {
    type: "SETTINGS_SELECT_FOREGROUND",
    foregroundSrc: foregroundSrc,
  }
}

export const settingsSelectImage = (image) => {
  return {
    type: "SETTINGS_SELECT_IMAGE",
    image: image
  }
}

export const settingsUpdateImage = (index, image) => {
  return {
    type: "SETTINGS_UPDATE_IMAGE",
    index: index,
    image: image
  }
}

export const settingsRemoveImage = (index) => {
  return {
    type: "SETTINGS_REMOVE_IMAGE",
    index: index
  }
}

export const settingsAddImageToCart = (image) => {
  return {
    type: "SETTINGS_ADD_IMAGE_TO_CART",
    image: image
  }
}

export const settingsRemoveImageFromCart = (index) => {
  return {
    type: "SETTINGS_REMOVE_IMAGE_FROM_CART",
    index: index
  }
}

export const settingsReset = () => {
  return {
    type: "SETTINGS_RESET"
  }
}
